


import SECTION_CONTACTUS_TITLE from
'../dynamic_section/dynamic_2/template_01';






import ContactUs from '../sections/contact_us/template_01';




import "./style.css";


const ContactUsPage = ()=>{
  
return (
  <div id="contactUsPage" class="page ">
  
  

  
  < SECTION_CONTACTUS_TITLE desktopToggle={ true }
    mobileToggle={ false } label={ `contactUs_title` } id={ `contactUs_title` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } numberOfImage={ 1 } titlePosition={ `start` }/>
  
  
  
  

  
  <ContactUs desktopTitleToggle={ true }
    mobileTitleToggle={ true } />
  
  
  

  
</div>
)
}

export default ContactUsPage;